import { render, staticRenderFns } from "./CartProductCard.vue?vue&type=template&id=38fef844&scoped=true"
import script from "./CartProductCard.vue?vue&type=script&lang=js"
export * from "./CartProductCard.vue?vue&type=script&lang=js"
import style0 from "./CartProductCard.vue?vue&type=style&index=0&id=38fef844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fef844",
  null
  
)

export default component.exports